import { withStyles } from "@material-ui/core";
import Details from "./Details";
const styles = (theme) => ({
  container: {
    display: "flex",
    color: theme.TextColor,
    alignItems: "center",
  },
  spacing: {
    marginRight: 8,
  },
});
const Label = ({ data, classes }) => (
  <div className={classes.container}>
    <Details
      containerClass={classes.spacing}
      label="Pickup# : "
      value={data.pickup.number}
    />
    <Details
      containerClass={classes.spacing}
      label="Shipper : "
      value={`${data.shipper.name} (${data.shipper.accountNumber}) | ${data.shipper.address}`}
    />
    {data.driver.id && (
      <Details
        containerClass={classes.spacing}
        label="Driver : "
        value={`${data.driver.name} (${data.driver.number})`}
      />
    )}
  </div>
);

export default withStyles(styles)(Label);
